import {environment} from '../../../environments/environment';

/**
 * Debug logger utility for score calculation services
 * Logs only when enableScoreCalculationLogs is true in environment
 */
export class DebugLogger {
  private static readonly isEnabled = environment.enableDebugLogs;

  static log(message: string, data?: unknown): void {
    if (this.isEnabled) {
      console.log(message, data ?? '');
    }
  }

  static warn(message: string, data?: unknown): void {
    if (this.isEnabled) {
      console.warn(message, data ?? '');
    }
  }

  static error(message: string, error?: unknown): void {
    console.error(message, error ?? '');
  }
}
